import { render } from "./Bilgiler.vue?vue&type=template&id=07760e91&scoped=true"
import script from "./Bilgiler.vue?vue&type=script&lang=js"
export * from "./Bilgiler.vue?vue&type=script&lang=js"

import "./Bilgiler.vue?vue&type=style&index=0&id=07760e91&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07760e91"]])

export default __exports__